import React from "react";
import loader from "../loader/redcliffe.gif";
function Loader() {
  return (
    <div className="loader-wrapper">
      <img src={loader} alt="Loading" />
    </div>
  );
}

export default Loader;
